// extracted by mini-css-extract-plugin
export default {"container":"detail-button_container__nuYKT"};